const signUpMapping = {

}

module.exports = { signUpMapping }